import React from 'react'
import { Field } from 'redux-form'
import { Input as TextInput } from 'components'

const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />

export const Control = ({ selectProps, innerRef, children, innerProps }) => (
  <Field
    fullWidth
    name={selectProps.name}
    label={selectProps.label}
    margin='normal'
    component={TextInput}
    InputProps={{
      inputComponent,
      inputProps: {
        className: selectProps.classes.input,
        inputRef: innerRef,
        children: children,
        ...innerProps,
      },
    }}
    {...selectProps.textFieldProps}
  />
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/Control/index.js